import React from 'react'
import * as layouts from '../../constants/layouts'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import { withStyles } from '@material-ui/core/styles'


const searchFieldStyles = (theme) => ({
	[layouts.NARROW]: {
		flex: 1
	},
	[layouts.WIDE]: {
		width: theme.spacing.unit * 25
	}
})

const SearchField = ({ searchTerm, layout, onChange, classes }) => (
	<FormControl margin="dense" className={classes[layout]}>
		<Input
			id = "search-stompunkt-id"
			value = {searchTerm}
			onChange = {onChange}
			placeholder = "Sök på ID"
			autoFocus
		/>
	</FormControl>
)

export default withStyles(searchFieldStyles)(SearchField)



// WEBPACK FOOTER //
// ./src/components/MapMenu/SearchField.js